import React, { useRef, useState, useEffect } from 'react';
import '../Styles/ContactForm.css';
import emailjs from '@emailjs/browser';
import Header from '../JS/Headers'

const ContactForm = () => {
    const form = useRef();
    const [isFormValid, setIsFormValid] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            'service_520g7ub', 'template_eybkf1r', form.current, '_Aw9AgkIXfiTQdy0Z')
            .then((result) => {
                setStatus('SUCCESS');
                e.target.reset()
                console.log(result.text);
            },
            (error) => {
                setFail('FAIL')
                console.log(error.text);
            });
        setIsFormValid(false);
    };
    
    const [status, setStatus] = useState('');
    const [fail, setFail] = useState('');

    // remove success/fail messages after 5 seconds
    useEffect(() => {
        if (status === 'SUCCESS') {
            setTimeout(() => {
                setStatus('');
            }, 5000)
        }
    }, [status]);

    useEffect(() => {
        if (fail === 'FAIL') {
            setTimeout(() => {
                setFail('');
            }, 5000)
        }
    }, [fail]);

    const alertSuccess = () => (
        <div className='success'>
            <p>✓ Your message was sent successfully!</p>
        </div>
    )

    const alertFail = () => (
        <div className='fail'>
            <p>✕ Your message was not sent. Please try again.</p>
        </div>
    )

    const handleInputChange = () => {
        const isValid = form.current.checkValidity();
        setIsFormValid(isValid);
    };

    return (
        <>
          <Header heading='Contact Us' subheading='ANY QUESTIONS?' />
          <div className='contact-form'>    
            <form ref={form} onSubmit={sendEmail}>
              <div className='contact-form-name-input'>
                <div className='contact-form-box'>
                  <label className='form-label required'>First Name</label>
                  <input
                    className='first_name_field'
                    placeholder='First Name'
                    type='text'
                    name='user_first_name'
                    required
                    onChange={handleInputChange}
                  />
                </div>
                <div className='contact-form-box'>
                  <label className='form-label required'>Last Name</label>
                  <input
                    className='last_name_field'
                    placeholder='Last Name'
                    type='text'
                    name='user_last_name'
                    required
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className='contact-form-box'>
                <label className='form-label required'>Email</label>
                <input
                  className='email_field'
                  placeholder='your@email.com'
                  type='email'
                  name='user_email'
                  required
                  onChange={handleInputChange}
                />
              </div>
              <div className='contact-form-box'>
                <label className='form-label required'>Message</label>
                <textarea
                  className='message_field'
                  placeholder='Type your message here'
                  rows='6'
                  type='text'
                  name='message'
                  required
                  onChange={handleInputChange}
                />
              </div>
              <input
                className={`submit-button ${!isFormValid ? 'disabled' : ''}`}
                type='submit'
                value='SUBMIT FORM ->'
                disabled={!isFormValid}
              />
            </form>
            {status && alertSuccess()}
            {fail && alertFail()}
          </div>
        </>
      );
    };

export default ContactForm;